/**
 * Форматирует номер телефона с кодом страны
 * @param {Array} codes - массив объектов стран [{value: 'US', label: 'United States +1', code: '+1'}]
 * @param {string} userCode - выбранный код страны (ISO: US, RU,...)
 * @param {string} phoneNumber - номер телефона в формате маски ((888) 222-33-44)
 * @returns {string} полный номер телефона с кодом страны (+18882223344)
 */
export function getFullPhoneNumber(codes, userCode, phoneNumber) {
    const countryCode = codes.find(c => c.value === userCode)?.code || '';
    if ( countryCode ) {
        const phone = phoneNumber.replace(/\D/g, ""); // Только цифры
        if ( phone.length ) {
            return `${countryCode}${phone}`;
        }
    }
    return '';
}

/**
 * Валидирует email адрес
 * @param {string} email - email для проверки
 * @returns {boolean} true если email валидный или пустой
 */
export function isValidEmail( email ) {
    // Регулярка для валидации email (рекомендуемый вариант)
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test( email ) || ! email;
}


